import { render, staticRenderFns } from "./transactionsHistory.vue?vue&type=template&id=42f59c90&"
import script from "./transactionsHistory.vue?vue&type=script&lang=js&"
export * from "./transactionsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports